import type React from "react";

import {Canvas} from "@react-three/fiber";

import {useGlobalEventDispatch} from "~/contexts/event/GlobalEventBusContext";
import {useGlobalKeyboardEvents} from "~/hooks/useGlobalKeyboardEvents";

interface MyCanvasProps {
  children: React.ReactNode;
}

const MyCanvas: React.FC<MyCanvasProps> = ({children}) => {
  const dispatch = useGlobalEventDispatch();
  useGlobalKeyboardEvents();

  return (
    <Canvas
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
      }}
      gl={{powerPreference: "high-performance", alpha: true}}
      onPointerDown={(e) => dispatch("pointerdown", e)}
      onPointerMove={(e) => dispatch("pointermove", e)}
      onPointerUp={(e) => dispatch("pointerup", e)}
      onPointerMissed={(e) => dispatch("pointermissed", e)}
      onPointerCancel={(e) => dispatch("pointercancel", e)}
      onTouchStart={(e) => dispatch("touchstart", e)}
      onTouchMove={(e) => dispatch("touchmove", e)}
      onTouchEnd={(e) => dispatch("touchend", e)}
      onWheel={(e) => dispatch("wheel", e)}
    >
      {children}
    </Canvas>
  );
};

export default MyCanvas;
